
const useTabs = () => {

    return [
        {
            id: 0,
            label: "סוללות מבדקים",
        },
        {
            id: 1,
            label: "מבדקים מבודדים"
        }
    ]

}


export default useTabs
